$ = require 'jquery'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'

{ featureFlagClient } = require '@trello/feature-flag-client'

InspirationPopover = require 'app/scripts/views/onboarding/inspiration-popover'
{ isInspirationBoard } = require 'app/scripts/views/onboarding/helpers'
InviteeOrientationView = require 'app/scripts/views/board/invitee-orientation-view'

module.exports.unmountInspirationPopover = ->
  if @inspirationPopoverDiv?
    ReactDOM.unmountComponentAtNode(@inspirationPopoverDiv)
    @inspirationPopoverDiv = null

module.exports.renderInspirationPopover = ->
  if !featureFlagClient.get('activation.onboarding_v2', false) || \
   !isInspirationBoard(@model.get('id'))
    return

  timeout = 0
  # Dont use a board-canvas element to mount, because then the popover will be unmounted
  # when a new board is selected from the popover
  # Corresponding code to remove popover is in controller/index.coffee
  if !@inspirationPopoverDiv
    timeout = 2000
    $('#surface').append('<div id="js-inspiration-popover-mount"></div>')
    @inspirationPopoverDiv = $('#js-inspiration-popover-mount')[0]

  setTimeout(=>
    ReactDOM.render(
      React.createElement(InspirationPopover, {
        onClose: @unmountInspirationPopover
        boardId: @model.get('id')
        @modelCache
      })
      , @inspirationPopoverDiv
    )
  , timeout)

  @

module.exports.renderInviteeOrientation = ->
  @$('.board-canvas').append('<div class="invitee-orientation-mount-point"></div>')

  inviteeOrientationView = @subview InviteeOrientationView, @model,
    modelCache: @modelCache

  @ensureSubview(inviteeOrientationView, @$('.invitee-orientation-mount-point'))
